import { BookingConfirmationTemplate } from "./booking-confirmation-template";

export class BookingConfirmationTemplateWithDetail extends BookingConfirmationTemplate {

    public body: string;

    constructor(
        id: number,
        name: string,
        body: string
    ){
        super(id, name);
        this.body = body;
    }
}
